import { get, isEmpty } from "lodash";

import { AppConfigs } from "../models/AppConfigs";
import { AppEnvironmentConfig } from "./AppConfigs";
import { initAfterConfigLoad } from "../utils";

/* Config from config.json - START */
export const updateConfigs = (data: AppConfigs) => {
  configs = data;
  configUrl = data.REACT_APP_TEMPO_CONFIG_URL;
  configUrlForUserManagement = data.REACT_APP_TEMPO_CONFIG_URL_USER;
  configUrlForReferral = data.REACT_APP_TEMPO_CONFIG_URL_REFERRAL;
  configUrlForNote = data.REACT_APP_TEMPO_CONFIG_URL_NOTE;
  configUrlForOperator = data.REACT_APP_TEMPO_CONFIG_URL_OPERATOR;
  appInsightConnString = data.REACT_APP_TEMPO_APPINSIGHTS_CONNECTION_STRING;
  appClientId = data.REACT_APP_TEMPO_CLIENT_ID;
  configUrlForScheduler = data.REACT_APP_TEMPO_HOST_CONFIG_URL_SCHEDULER;
  configUrlForBlob = data.REACT_APP_TEMPO_CONFIG_URL_BLOB;
  configUrlForCheckEligibility =
    data.REACT_APP_TEMPO_CONFIG_URL_CHECK_ELIGIBILITY;
  configUrlForPayerEligibility =
    data.REACT_APP_TEMPO_HOST_CONFIG_URL_PAYER_ELIGIBILITY;
  appLoginURL = data.REACT_APP_TEMPO_LOGIN_URL;
  reactAppDebug = Number(data.REACT_APP_TEMPO_DEBUG);
  googleMapKey = data.REACT_APP_TEMPO_GOOGLE_MAP_KEY;
  surveyJsKey = data.REACT_APP_TEMPO_SURVEY_JS_KEY;
  googleMapUrl = data.REACT_APP_TEMPO_GOOGLE_MAP_API_URL;
  documentMaxSize = data.REACT_APP_TEMPO_DOCUMENT_MAX_SIZE;
  documentMinSize = !isEmpty(data.REACT_APP_TEMPO_DOCUMENT_MIN_SIZE) ? data.REACT_APP_TEMPO_DOCUMENT_MIN_SIZE : "1KB";
  documentFaxMaxSize = data.REACT_APP_TEMPO_FAX_MAX_SIZE.split("MB")[0];
  isProductionEnvironment = Number(data.REACT_APP_TEMPO_IS_PRODUCTION_ENV);
  defaultDinaUrl = data.REACT_APP_TEMPO_DINA_DEFAULT_URL;
  apiCallInterval = Number(data.REACT_APP_TEMPO_API_CALL_INTERVAL_MINUTE);
  initAfterConfigLoad();
};

export const updateVariables = (variables: any) => {
  const {
    REACT_APP_TEMPO_APPINSIGHTS_CONNECTION_STRING,
    REACT_APP_TEMPO_CLIENT_ID,
    REACT_APP_TEMPO_LOGIN_URL,
    REACT_APP_TEMPO_CONFIG_URL_REFERRAL,
  } = variables;

  appInsightConnString = REACT_APP_TEMPO_APPINSIGHTS_CONNECTION_STRING;
  appClientId = REACT_APP_TEMPO_CLIENT_ID;
  appLoginURL = REACT_APP_TEMPO_LOGIN_URL;
  configUrlForReferral = REACT_APP_TEMPO_CONFIG_URL_REFERRAL;

  Object.assign(configs, {
    REACT_APP_TEMPO_APPINSIGHTS_CONNECTION_STRING,
    REACT_APP_TEMPO_CLIENT_ID,
    REACT_APP_TEMPO_LOGIN_URL,
    REACT_APP_TEMPO_CONFIG_URL_REFERRAL,
  });

}

export let configs: AppConfigs = {
  REACT_APP_TEMPO_CONFIG_URL: "",
  REACT_APP_TEMPO_CONFIG_URL_USER: "",
  REACT_APP_TEMPO_CONFIG_URL_REFERRAL: "",
  REACT_APP_TEMPO_CONFIG_URL_NOTE: "",
  REACT_APP_TEMPO_CONFIG_URL_OPERATOR: "",
  REACT_APP_TEMPO_APPINSIGHTS_CONNECTION_STRING: "",
  REACT_APP_TEMPO_CLIENT_ID: "",
  REACT_APP_TEMPO_HOST_CONFIG_URL_SCHEDULER: "",
  REACT_APP_TEMPO_CONFIG_URL_BLOB: "",
  REACT_APP_TEMPO_CONFIG_URL_CHECK_ELIGIBILITY: "",
  REACT_APP_TEMPO_HOST_CONFIG_URL_PAYER_ELIGIBILITY: "",
  REACT_APP_TEMPO_LOGIN_URL: "",
  REACT_APP_TEMPO_DEBUG: "0",
  REACT_APP_TEMPO_GOOGLE_MAP_KEY: "",
  REACT_APP_TEMPO_SURVEY_JS_KEY: "",
  REACT_APP_TEMPO_GOOGLE_MAP_API_URL: "",
  REACT_APP_TEMPO_DOCUMENT_MAX_SIZE: "",
  REACT_APP_TEMPO_DOCUMENT_MIN_SIZE: "",
  REACT_APP_TEMPO_FAX_MAX_SIZE: "",
  REACT_APP_TEMPO_IS_PRODUCTION_ENV: "1",
  REACT_APP_TEMPO_DINA_DEFAULT_URL: "",
  REACT_APP_TEMPO_API_CALL_INTERVAL_MINUTE: "0",
};
export let configUrl = configs.REACT_APP_TEMPO_CONFIG_URL ;
export let configUrlForUserManagement =
  configs.REACT_APP_TEMPO_CONFIG_URL_USER ;
export let configUrlForReferral =
  configs.REACT_APP_TEMPO_CONFIG_URL_REFERRAL ;
export let configUrlForNote = configs.REACT_APP_TEMPO_CONFIG_URL_NOTE ;
export let configUrlForScheduler =
  configs.REACT_APP_TEMPO_HOST_CONFIG_URL_SCHEDULER ;
export let configUrlForOperator =
  configs.REACT_APP_TEMPO_CONFIG_URL_OPERATOR ;
export let appInsightConnString =
  configs.REACT_APP_TEMPO_APPINSIGHTS_CONNECTION_STRING ;
export let configUrlForBlob = configs.REACT_APP_TEMPO_CONFIG_URL_BLOB ;
export let configUrlForCheckEligibility =
  configs.REACT_APP_TEMPO_CONFIG_URL_CHECK_ELIGIBILITY ;
export let configUrlForPayerEligibility =
  configs.REACT_APP_TEMPO_HOST_CONFIG_URL_PAYER_ELIGIBILITY ;
export let appClientId = configs.REACT_APP_TEMPO_CLIENT_ID ;
export let googleMapKey = configs.REACT_APP_TEMPO_GOOGLE_MAP_KEY ;
export let surveyJsKey = configs.REACT_APP_TEMPO_SURVEY_JS_KEY ;
export let googleMapUrl = configs.REACT_APP_TEMPO_GOOGLE_MAP_API_URL ;
export let appLoginURL = configs.REACT_APP_TEMPO_LOGIN_URL ;
export let reactAppDebug = Number(configs.REACT_APP_TEMPO_DEBUG);
export let documentMaxSize = configs.REACT_APP_TEMPO_DOCUMENT_MAX_SIZE ;
export let documentMinSize = configs.REACT_APP_TEMPO_DOCUMENT_MIN_SIZE ;
export let documentFaxMaxSize = configs.REACT_APP_TEMPO_FAX_MAX_SIZE ;
export let isProductionEnvironment = Number(configs.REACT_APP_TEMPO_IS_PRODUCTION_ENV);
export let defaultDinaUrl = configs.REACT_APP_TEMPO_DINA_DEFAULT_URL;
export let apiCallInterval = Number(configs.REACT_APP_TEMPO_API_CALL_INTERVAL_MINUTE);

/* Config from config.json - END */

/* App level config constants - START */

//Check if running as localhost
export const IS_LOCALHOST: boolean =
  get(process.env, "NODE_ENV", "") === AppEnvironmentConfig.DEV;

//Applied endpoint for localhost -> can be changed via CLI e.g. set REACT_APP_ENDPOINT_ENV=SB
export const REACT_APP_ENDPOINT_ENV = get(
  process.env,
  "REACT_APP_ENDPOINT_ENV",
  ""
);

/* App level config constants - END */
